import Layout from "@/components/layout/Layout";
import { COMPANY_FISCAL_DATA, LOCATION_FISCAL_DATA } from "@/constants/fiscal";

const PoliticaPrivacidad = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="font-serif text-4xl font-bold text-primary mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">1. Responsable del Tratamiento</h2>
            <div className="bg-muted/50 p-6 rounded-lg">
              <ul className="space-y-2 text-foreground">
                <li><strong>Responsable:</strong> {COMPANY_FISCAL_DATA.razonSocial}</li>
                <li><strong>CIF:</strong> {COMPANY_FISCAL_DATA.cif}</li>
                <li><strong>Domicilio:</strong> {LOCATION_FISCAL_DATA['felo-monzon'].fullAddress}</li>
                <li><strong>Teléfono:</strong> {LOCATION_FISCAL_DATA['felo-monzon'].phone}</li>
                <li><strong>Email:</strong> info@pasteleriareres.es</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">2. Finalidad del Tratamiento</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Los datos personales que nos facilite serán tratados con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Gestión de pedidos online y encargos personalizados.</li>
              <li>Envío de confirmaciones y notificaciones relativas a sus pedidos.</li>
              <li>Facturación y cumplimiento de obligaciones fiscales.</li>
              <li>Atención al cliente y resolución de consultas.</li>
              <li>Envío de comunicaciones comerciales (solo con su consentimiento expreso).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">3. Legitimación</h2>
            <p className="text-muted-foreground leading-relaxed">
              La base legal para el tratamiento de sus datos es la ejecución de un contrato (pedidos), 
              el cumplimiento de obligaciones legales (facturación) y el consentimiento del interesado 
              (comunicaciones comerciales).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">4. Categorías de Datos</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Los datos personales que tratamos incluyen:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li><strong>Datos identificativos:</strong> nombre y apellidos.</li>
              <li><strong>Datos de contacto:</strong> teléfono, email.</li>
              <li><strong>Datos de transacción:</strong> historial de pedidos, preferencias de productos.</li>
              <li><strong>Datos de facturación:</strong> cuando sea necesario para la emisión de facturas completas.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">5. Destinatarios</h2>
            <p className="text-muted-foreground leading-relaxed">
              Sus datos podrán ser comunicados a:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-4">
              <li>Entidades financieras para la gestión de pagos (Stripe).</li>
              <li>Administraciones públicas cuando así lo exija la ley (Agencia Tributaria Canaria).</li>
              <li>Proveedores de servicios tecnológicos necesarios para la operativa del sitio web.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">6. Conservación de Datos</h2>
            <p className="text-muted-foreground leading-relaxed">
              Los datos se conservarán durante el tiempo necesario para cumplir con la finalidad para la 
              que se recabaron y para determinar las posibles responsabilidades derivadas. En el caso de 
              datos fiscales, se conservarán durante el plazo legal establecido (mínimo 4 años).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">7. Derechos del Interesado</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Tiene derecho a:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li><strong>Acceso:</strong> conocer qué datos personales tratamos sobre usted.</li>
              <li><strong>Rectificación:</strong> modificar datos inexactos o incompletos.</li>
              <li><strong>Supresión:</strong> solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
              <li><strong>Limitación:</strong> solicitar la limitación del tratamiento en determinados casos.</li>
              <li><strong>Portabilidad:</strong> recibir sus datos en formato estructurado.</li>
              <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos.</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Para ejercer estos derechos, puede contactarnos en info@pasteleriareres.es indicando 
              claramente el derecho que desea ejercer y acompañando copia de su DNI.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">8. Seguridad</h2>
            <p className="text-muted-foreground leading-relaxed">
              {COMPANY_FISCAL_DATA.razonSocialCorta} ha adoptado las medidas técnicas y organizativas 
              necesarias para garantizar la seguridad e integridad de sus datos personales, así como 
              para evitar su alteración, pérdida, tratamiento o acceso no autorizado.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">9. Sistema Verifactu</h2>
            <p className="text-muted-foreground leading-relaxed">
              Las facturas simplificadas generadas a través de nuestro sistema cumplen con la normativa 
              Verifactu (RD 1007/2023) y son reportadas a la Agencia Tributaria Canaria. Los datos 
              fiscales incluidos en estas facturas se conservan conforme a la legislación tributaria vigente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">10. Reclamaciones</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si considera que el tratamiento de sus datos no se ajusta a la normativa vigente, puede 
              presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground text-center">
            Última actualización: Enero 2026
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default PoliticaPrivacidad;
